<label [class.dirty]="!!searchInput.value" [class.orderHistorySearch]="orderHistorySearch"
    [class.quickOrder]="quickOrder">
    <input type="text" #searchInput [(ngModel)]="searchValue" [placeholder]="searchPlaceholder" autocomplete="off"
        aria-describedby="initialDescription" aria-controls="results" aria-autocomplete="both"
        (input)="search(searchInput.value);$event.stopPropagation()" (click)="open()" (focus)="open()"
        (keydown.escape)="onBlur()" (keydown.enter)="
    launchSearchResult($event, searchInput.value);
    " value="{{ chosenWord }}" />

    <button type="button" class="close-icon" *ngIf="searchValue" (click)="onBlur();$event.preventDefault()">
        <img [src]="'../../../assets/icons/'+baseSiteId+'/close.svg'" alt="close_icon">
    </button>
    <button role="presentation" class="search-icon" [disabled]="searchInput.value.length === 0"
        *ngIf="!orderHistorySearch || (orderHistorySearch && !searchValue)">
        <!-- (click)="launchSearchResult($event, searchInput.value)" -->
        <img [src]="'../../../assets/icons/'+baseSiteId+'/search_new.svg'" alt="Search Icon">
        <!-- <cx-icon [type]="iconTypes.SEARCH" (click)="launchSearchResult($event, searchInput.value)"></cx-icon> -->
    </button>
</label>

<!-- results list -->
<div *ngIf="
    closeDropDown && !hideSearchHistory && !quickOrder && !orderHistorySearch && results$ | async as result 
  " class="results" id="results" role="listbox">
    <ul class="products" *ngIf="result.products" tabindex="0">
        <li class="drop-down-header">
            <span class="drop-down-title">
                {{ "pt.matchingProducts" | cxTranslate }}
            </span>
            <a class="push-right all-results-link" (click)="launchSearchResult($event, searchInput.value)">{{
                "pt.seeAll" |
                cxTranslate }}</a>
        </li>

        <li *ngFor="let product of result.products | slice:0:4">
            <a [class.has-media]="config.displayProductImages" [routerLink]="['/product', product.code, product.code]"
                [queryParams]="{ variantSelected: true}" (blur)="close($event)" (click)="close($event, true)">
                <cx-media [container]="(product?.images?.PRIMARY)!=null?(product?.images?.PRIMARY):undefine"
                    format="thumbnail " role="presentation " class=""></cx-media>
                <!-- <img *ngIf="config.displayProductImages && product?.images === undefined" [src]="fallbackImage" format="thumbnail " role="presentation " class="thumbnail-img" alt="defImg" /> -->
                <div class="name" [innerHTML]="product.baseProductInfo.name"></div>
                <div class="name" [innerHTML]="product.baseProductInfo.baseProductDescription"></div>
            </a>
        </li>
    </ul>
    <!-- categories list -->
    <ul class="categories" *ngIf="(suggestions$ | async)?.categories.length > 0">
        <li class="drop-down-header">
            <span class="drop-down-title"> Categories </span>
        </li>
        <li *ngFor="let suggestion of (suggestions$ | async)?.categories">
            <div class="firstLetter" [innerHTML]="suggestion.name.at(0)"></div>
            <div class="name" [innerHTML]="suggestion.name" (click)="navigateToCategory(suggestion)"></div>
        </li>
    </ul>
</div>
<!-- recent searches -->
<div *ngIf="
    closeDropDown && hideSearchHistory && !quickOrder && !orderHistorySearch && !returnSearch && value$ | async as item 
  " role="listbox" class="searchHistory" id="searchHistory">
    <ul class="products resetListStyle" *ngIf="item.recentSearchText">
        <li class="drop-down-header">
            <span class="drop-down-title history-font-size">{{
                "pt.recentSearches" | cxTranslate
                }}</span>
        </li>
        <li class="itemHistory" *ngFor="let item of item.recentSearchText" (click)="goToSearch(item)">
            <a (blur)="close($event)" (click)="close($event, true)"> {{ item }}</a>
        </li>
    </ul>
</div>

<!-- quick order -->
<div *ngIf="quickOrder && showQuickOrder && results$ | async as result" class="results" id="quickOrder" role="listbox"
    (blur)="onBlur()">
    <ul class="products no-products" *ngIf="result?.products?.length === 0 && result?.message != null" tabindex="0">
        <li>
            <a class="resultnot-found">
                {{ "pt.noResultsFound" | cxTranslate }}
            </a>
        </li>
    </ul>
    <ul class="products" *ngIf="result?.products?.length > 0" tabindex="0">

        <ng-container *ngFor="let product of result.products">
            <ng-container *ngIf="product.baseProductInfo.variantInfo.length > 0;else idSearch">
                <li *ngFor="let variant of product.baseProductInfo.variantInfo;let i = index">
                    <a>
                        <div class="name" (click)="quickOrderClick(product,i)">
                            <span [innerHTML]="product.baseProductInfo.name"></span>&nbsp;<span
                                [innerHTML]="product.baseProductInfo.baseProductDescription"></span>
                        </div>
                        <span class="descriptionSpan"
                            [innerHTML]="getDescription(variant.description,variant.code)"></span>
                        <p class="season" *ngIf="variant.flu && variant.fluCategories">
                            {{variant.fluCategories[0]}}&nbsp;Formula</p>
                    </a>
                </li>
            </ng-container>
            <ng-template #idSearch>
                <a>
                    <div class="name" (click)="quickOrderClick(product)">
                        {{product.baseProductInfo.name}}&nbsp;<span
                            [innerHTML]="product.baseProductInfo.baseProductDescription"></span>
                    </div>
                    <p>{{product.description}}({{product.code}})</p>
                    <p class="season" *ngIf="product.flu">{{product.fluCategories[0]}}&nbsp;Formula</p>
                </a>
            </ng-template>
        </ng-container>

    </ul>
</div>

<!-- show order history -->
<div *ngIf="orderHistorySearch && showOrderHistory && results$ | async as result" class="results"
    id="orderHistorySearch" role="listbox" (blur)="onBlur()">
    <ul class="products" *ngIf="result?.products?.length === 0 && result?.message != null" tabindex="0">
        <li>
            <a class="resultnot-found">
                {{ "pt.noResultsFound" | cxTranslate }}
            </a>
        </li>
    </ul>
    <ul class="products" *ngIf="result.products" tabindex="0">
        <ng-container *ngFor="let product of result.products">
            <li *ngFor="let variant of product.baseProductInfo.variantInfo; let i = index">
                <a (click)="orderHistoryClick(product,i)" class="orderHistorySearch">
                    <div class="name prodName" [innerHTML]="product.baseProductInfo.name"
                        (click)="orderHistoryClick(product,i)"></div>
                    <div class="name descriptionProd" [innerHTML]="product.baseProductInfo.baseProductDescription">
                    </div>
                    <div class="descriptionProdSub" [innerHTML]="variant.description + ' (' + variant.code +')'"></div>
                </a>
            </li>
        </ng-container>

    </ul>
</div>


<!-- show returns history -->
<div *ngIf="returnSearch && showReturnHistory && returnSearchHistory$ | async as result" class="results"
    id="showReturnHistory" role="listbox" (blur)="onBlur()">
    <ul class="products" *ngIf="!result?.products?.length" tabindex="0">
        <li>
            <a class="resultnot-found">
                {{ "pt.noResultsFound" | cxTranslate }}
            </a>
        </li>
    </ul>
    <ul class="products" *ngIf="result.products.length" tabindex="0">
        <li *ngFor="let product of result.products">
            <a>
                <div class="name" (click)="returnHistoryClick(product)">
                    <span
                        [innerHTML]="product.baseProductInfo.name"></span>&nbsp;<span>{{returnText(product.baseProductDescription)}}
                    </span><br><span class="product-desc-bold" [innerHTML]="product?.description"></span><span
                        class="product-desc-bold">(<span>{{product.code}}</span>)</span>
                </div>
            </a>
        </li>
    </ul>
</div>